import { Component, Inject, Input, OnInit } from "@angular/core";
import { FormGroup, FormControl, Validators, AbstractControl } from "@angular/forms";
import { Header, AccessFlow, Asset } from "@aptsi-types";
import { ActivatedRoute, Router } from "@angular/router";
import { AccessFlowRuleset } from "@aptsi-types";
import { AccessFlowService } from "../access-flow.service";
import { AccessFlowRulesetService } from "../../access-flow-ruleset/access-flow-ruleset-create-or-update/access-flow-ruleset.service";
import { AssetService } from "../../asset/asset.service";
import { MAT_DIALOG_DATA, MatDialog } from "@angular/material/dialog";
import { DeleteDialogComponent } from "../../shared/dialogs/delete-dialog/delete-dialog.component";
import { ErrorDialogComponent } from "../../shared/dialogs/error-dialog.component";
import { SuccessDialogComponent } from "../../shared/dialogs/success-dialog/success-dialog.component";
import { delay, switchMap, map, tap } from "rxjs/operators";
import { AccessFlowNodePopupDialogComponent } from "../access-flow-node-popup.component";
import { AdaptiveAccessNodeService } from "../../adaptive-access-node/adaptive-access-node.service";
import { TableService } from "src/app/shared/table/table.service";
import { KeycloakStateService } from 'src/app/core/service/utility.service';
import { EnvironmentService } from "src/app/core/service/environment.service";

@Component({
  selector: "app-access-flow-create-or-update",
  templateUrl: "./access-flow-create-or-update.component.html",
  styleUrls: ["./access-flow-create-or-update.component.scss"],
})
export class AccessFlowCreateOrUpdateComponent implements OnInit {
  accessFlowRuleset: AccessFlowRuleset[] = [];

  isCreate: boolean = false;
  isFinish: boolean = false;
  existingAccessFlowId: string = null;
  existingFlowId: string = null;
  showModal: boolean = false;
  accessFlow: AccessFlow = null;
  form: FormGroup;
  filteredDataToSearch: any[] = [];
  assets: Asset[] = [];
  nullver: number = null;
  organizationId: string;

  isNext: boolean = false;
  isTableVisible: boolean = false;
  existingAdptiveAccessNodeConfName: string = "";
  numberOfNodes: number;
  selectedEntries: any[] = [];
  selectedTab: 'accessFlow' | 'aacNodeAuth' = 'accessFlow';
  finalEntries: any[];

buttonConfig = {
  update: false,
  delete: false,
  import: false,
  configure: false
};

handleAction(event: any) {
  console.log(event);
}

  

  headers: Header[] = [
    {
      name: "Adaptive Access Node Id",
      property: "adaptiveaccessnodeid",
      showInDropdown: true,
    },
    {
      name: "Adaptive Access Node Type",
      property: "adaptiveAccessNodeType",
      showInDropdown: true,
    },
    {
      name: "Adaptive Access Node Name",
      property: "adaptiveAccessNodeName",
      showInDropdown: true,
    },
  ];

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private accessFlowService: AccessFlowService,
    private dialog: MatDialog,
    private accessFlowRulesetService: AccessFlowRulesetService,
    private assetService: AssetService,
    private adaptiveAccessControlService: AdaptiveAccessNodeService,
    private tableService: TableService,
    private keycloakStateService: KeycloakStateService,
    public environmentService: EnvironmentService
  ) { }


  principalTypes = [];




  async ngOnInit(): Promise<void> {
    this.organizationId = this.keycloakStateService.getOrganizationId(); // <-- Retrieve here
    console.log('Organization ID in component:', this.organizationId);
    this.isCreate = Boolean(this.route.snapshot.data.create);

    this.existingFlowId = this.route.snapshot.params.accessFlowId;


    //this.selectedEntries = this.accessFlowService.getFinalEntries();





    this.form = this.isCreate
      ? new FormGroup({
        accessControlFlowName: new FormControl(null, Validators.required),

        assetId: new FormControl(null, Validators.required),
        principalTypeId: new FormControl(null, Validators.required),
        isActive: new FormControl(true) // default to active for new flows
      })
      : new FormGroup({
        accessControlFlowName: new FormControl(
          this.accessFlow ? this.accessFlow.name : null,
          Validators.required
        ),
        assetId: new FormControl(
          this.accessFlow ? this.accessFlow.assetid : null,
          Validators.required
        ),
        accessFlowId: new FormControl(
          this.accessFlow ? this.accessFlow.accessflowid : null,
          Validators.required
        ),
        principalTypeId: new FormControl(
          this.accessFlow ? this.accessFlow.principaltypeid : null,
          Validators.required
        ),
        isActive: new FormControl(
          this.accessFlow ? this.accessFlow.isActive : true,
          Validators.required
        )
      });

          if (!this.isCreate) {
      await this.fetchAccessFlow();   // 🔥 must await
      await this.fetchAdaptiveAccessNodes();
      this.isNext=true;
    }


    await this.fetchPricipalTypes();

    await this.fetchAssets();
    this.filteredDataToSearch = this.assets.map((w) => {
      return {
        text: w.name,
        value: w.assetId,
      };
    });




    this.tableService.resetClickedRows();
    // 🔹 Ensure we get the latest entries from the service on load
    //this.finalEntries = this.accessFlowService.getFinalEntries();

    // 🔹 Subscribe to changes and update the UI when the service updates
    this.accessFlowService.finalEntries$.subscribe(entries => {
      this.finalEntries = [...entries]; // Create a new reference to trigger change detection
      this.selectedEntries = [...this.finalEntries];
      console.log("Final entries updated in main component:", this.finalEntries);
    });




  }


  async fetchAssets() {
    try {
      const response = await this.assetService
        .getAssets()
        .toPromise();
      this.assets = response["Resource retrieved successfully"] || [];
      //this.assets.sort((a, b) => a.assetId - b.assetId);
    } catch (error) {
      console.error("Error fetching Assets:", error);
    }
  }

  async fetchPricipalTypes() {
    try {
      const response = await this.accessFlowService
        .getsPrincipalType()
        .toPromise();
      this.principalTypes = response["Resource retrieved successfully"] || [];

      console.log('principal types', this.principalTypes);
      //this.assets.sort((a, b) => a.assetId - b.assetId);
    } catch (error) {
      console.error("Error fetching Assets:", error);
    }
  }

  typeValidator(control: AbstractControl): { [key: string]: any } | null {
    const selectedType = control.value;
    if (selectedType === "None") {
      return { noneSelected: true };
    }
    return null;
  }



  lookup(e) {
    this.filteredDataToSearch = this.assets
      .filter((i) => i.name.toString().toLowerCase().indexOf(e) > -1)
      .map((w) => {
        return {
          text: w.name,
          value: w.assetId,
        };
      });
  }

  clean(t) {
    t.value = "";
    this.lookup(t.value);
  }

async fetchAccessFlow() {
  try {
    const response = await this.accessFlowService
      .getAccessFlow(this.existingFlowId)
      .toPromise();

    this.accessFlow = response["Resource retrieved successfully"]
      ? response["Resource retrieved successfully"][0]
      : null;

    if (this.accessFlow) {
      this.form.patchValue({
        accessControlFlowName: this.accessFlow.name,
        accessFlowId: this.accessFlow.accessflowid,
        assetId: this.accessFlow.assetid,
        principalTypeId: this.accessFlow.principaltypeid,
        isActive: this.accessFlow.isActive
      });
    }

    this.isTableVisible = true;

    // 🔥 IMPORTANT: ENABLE AAC NODE AUTH TAB
    this.isNext = true;

  } catch (error) {
    console.error("Error fetching accessflows:", error);
  }
}


async fetchAdaptiveAccessNodes() {
  try {
    this.isTableVisible = true;

    const newresponse = await this.accessFlowService
      .getAdaptiveAccessNodes(this.accessFlow.accessflowid)
      .toPromise();

    // 🔥 SEND DATA TO BehaviorSubject
    this.accessFlowService.setFinalEntries(newresponse);

    // 🔥 update local arrays
    this.finalEntries = [...newresponse];
    this.selectedEntries = [...newresponse];

    console.log("Nodes fetched:", this.finalEntries);
  } catch (error) {
    console.error("Error fetching accessflow nodes:", error);
  }
}




  async openPopup() {
    try {
      // Reset selected entries for the current group
      this.accessFlowService.setFinalEntries([...this.selectedEntries]); // Ensures correct data is passed

      const dialogRef = this.dialog.open(AccessFlowNodePopupDialogComponent, {
        data: {
          title: "Select Adaptive Access Nodes",
          message: "The rule has been deleted successfully.",
          selectedEntries: [...this.selectedEntries], // Pass fresh selected entries
        },
        width: "1200px",
        height: "800px"
      });

      this.isTableVisible = true;

      dialogRef.afterClosed().subscribe(() => {
        this.finalEntries = this.accessFlowService.getFinalEntries();
        console.log("Final entries reloaded after popup closed:", this.finalEntries);
      });

    } catch (error) {
      console.error("Error opening popup:", error);
    }
  }


  async add() {
    try {
      if (!this.isCreate) {

        await this.accessFlowService
          .updateNodeConfig(
            // this.existingAdptiveAccessNodeConfId,
            this.form.value.accessFlowId,
            this.finalEntries.map((entry) => entry.adaptiveaccessnodeid)
          )
          .toPromise();
        this.openSuccessDialog(this.isCreate);
        //this.finish();
      } else {
        // console.log("node info :",this.existingAccessFlowId,this.selectedEntries)
        await this.accessFlowService
          .addNodeConfig(
            // this.form.value.adaptiveaccessNodeConfigId,
            this.existingAccessFlowId,
            this.finalEntries.map((entry) => entry.adaptiveaccessnodeid)
          )
          .toPromise();

        this.isFinish = !this.isFinish;
      }
      //this.openSuccessDialog(this.isCreate);
    } catch (error) {
      console.error(
        "Error creating Adaptive Access Node Configuration:",
        error
      );
    }
  }


  async deleteAacNode(index: number) {

    try {
      if (this.isCreate) {
        if (index >= 0 && index < this.selectedEntries.length) {
          this.selectedEntries.splice(index, 1); // Remove the entry at the specified index
          console.log(`Deleted entry at index: ${index}`);
        } else {
          console.warn(`Invalid index: ${index}`);
        }
      }
      else {
        await this.adaptiveAccessControlService
          .deleteadaptiveaccessnodes(this.selectedEntries[index].adaptiveaccessnodeid)
          .toPromise();

        const newresponse = await this.accessFlowService
          .getAdaptiveAccessNodes(this.accessFlow.accessflowid)
          .toPromise();
        this.selectedEntries = newresponse;

        this.dialog.open(DeleteDialogComponent, {
          data: {
            title: "Adaptive Access Node Deleted Successfully",
            message: "The adaptive access node has been deleted successfully.",
          },
        });
      }
    } catch (error) {
      console.error("Error deleting Adaptive Access Node:", error);
    }

  }



  cancel() {
    this.router.navigate(["ada-access/auth-tools/access-flow/search"]);
  }

  async submit() {
    try {

      if (this.isCreate) {
        const response = await this.accessFlowService
          .createAccessFlow(
            // this.form.value.accessFlowId,
            this.form.value.accessControlFlowName,
            this.form.value.assetId,
            this.form.value.principalTypeId,
            this.form.value.isActive,
            this.organizationId
          )
          .toPromise();

        this.existingAccessFlowId = response["Resource created successfully"][0].accessflowid;


        //this.openSuccessDialog(this.isCreate);
        this.isNext = true;
        this.selectedTab = 'aacNodeAuth';

      } else {
        await this.accessFlowService
          .updateAccessFlow(
            this.form.value.accessFlowId,
            this.form.value.accessControlFlowName,
            this.form.value.assetId,
            this.form.value.principalTypeId,
            this.form.value.isActive,
            this.organizationId
          )
          .toPromise();
        //this.add();
        this.openSuccessDialog(this.isCreate);
      }
    } catch (error) {
      this.openErrorDialog(error.message || "An unexpected error occurred.");
    }
  }


  async finish() {

    await this.accessFlowService
      .saveFlow()
      .toPromise();

    this.openSuccessDialog(this.isCreate);

    this.tableService.resetClickedRows();
  }


  openSuccessDialog(isCreate: boolean): void {
    const dialogRef = this.dialog.open(SuccessDialogComponent, {
      width: "250px",
      data: { isCreate: isCreate, title: "Acces Flow" },
    });

    dialogRef.afterClosed().subscribe((result) => {
      this.router.navigate(["ada-access/auth-tools/access-flow/search"]);
    });
  }

  openErrorDialog(errorMessage: string): void {
    const dialogRef = this.dialog.open(ErrorDialogComponent, {
      width: "250px",
      data: { errorMessage: errorMessage },
    });

    dialogRef.afterClosed().subscribe((result) => {
      this.router.navigate(["ada-access/auth-tools/access-flow/search"]);
    });
  }


}